// 1. 导入我们具体的 HTTP 服务器实现
import { SoraVideoHttpServer } from '~/servers/SoraVideoHttpServer.js';

// 2. 导入我们之前打包好的"工具箱"
import { allTools } from '~/tools/index.js';

function resolvePort(): number {
  const portFromEnv = process.env.PORT;
  if (!portFromEnv) {
    return 8080;
  }

  const parsed = Number.parseInt(portFromEnv, 10);
  if (Number.isNaN(parsed) || parsed < 0) {
    console.warn(
      `[Main] Invalid PORT environment value "${portFromEnv}". Falling back to default 8080.`,
    );
    return 8080;
  }

  return parsed;
}

function resolveHost(): string {
  const hostFromEnv = process.env.HOST;
  if (!hostFromEnv) {
    return '0.0.0.0';
  }

  return hostFromEnv;
}

/**
 * 这是我们整个应用程序的主函数 (main function)。
 * 它的职责是：组装并启动服务器。
 */
async function main() {
  console.log('====================================');
  console.log('🎬 Starting Sora Video MCP Server (HTTP Mode)...');
  console.log('====================================');

  // 3. 创建一个服务器实例，监听指定端口和主机（默认端口 8080，默认主机 0.0.0.0，可通过环境变量覆盖）
  const port = resolvePort();
  const host = resolveHost();
  console.log(`[Main] Server will listen on ${host}:${port}.`);
  const server = new SoraVideoHttpServer(port, host);

  // 4. 加载工具：遍历我们的“工具箱”，把每一个工具都注册到服务器里
  for (const tool of allTools) {
    server.registerTool(tool);
  }
  
  console.log(`[Main] ${allTools.length} tools have been registered.`);

  // 5. 启动服务器！
  //    这将启动 Web 服务器并开始监听网络请求。
  try {
    await server.start();
  } catch (error) {
    console.error('[Main] A fatal error occurred during server startup:', error);
    process.exit(1); // 如果启动失败，程序退出
  }
}

// 6. 执行主函数，让一切运转起来！
main();
